var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "contentBox",
    { attrs: { loading: _vm.loading } },
    [
      _vm.parcelId
        ? _c("parcel", {
            attrs: {
              handleClose: _vm.parcelClose,
              handleSelfRoute: _vm.parcelSelfRoute,
              handleTab: _vm.parcelTab,
              tab: _vm.tab,
              id: _vm.parcelId,
              noMarker: true,
              noZoomTo: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column h-100" },
        [
          _vm.collection
            ? _c(
                "contentTitle",
                {
                  class: _vm.$route.params.parcelId ? "d-none" : "",
                  attrs: {
                    variant: _vm.selected.length === 0 ? "" : "blue",
                    label: "COLLECTION",
                    close: "routeClose"
                  }
                },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.collection.name))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode !== null
            ? _c(
                "contentModal",
                { class: _vm.$route.params.parcelId ? "d-none" : "" },
                [
                  _vm.mode === "edit"
                    ? _c("collectionEdit", {
                        attrs: { collection: _vm.collection },
                        on: {
                          close: function($event) {
                            return _vm.setMode(null)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "export"
                    ? _c("collectionParcelExport", {
                        attrs: { collection: _vm.collection },
                        on: {
                          close: function($event) {
                            return _vm.setMode(null)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "remove"
                    ? _c("collectionRemove", {
                        attrs: { collection: _vm.collection },
                        on: {
                          close: function($event) {
                            return _vm.setMode(null)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "removeSelected"
                    ? _c("collectionRemoveSelected", {
                        attrs: { selected: _vm.selected },
                        on: {
                          parcelsRemoved: function($event) {
                            return _vm.parcelsRemoved()
                          },
                          close: function($event) {
                            return _vm.setMode(null)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "contentBody",
            {
              class: _vm.$route.params.parcelId ? "d-none" : "",
              attrs: { locked: _vm.token === null, bg: "#f8f9fa" }
            },
            [
              _vm.selected.length === 0
                ? _c("contentActions", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-light btn-sm",
                        class: { active: _vm.mode === "export" },
                        on: {
                          click: function($event) {
                            return _vm.setMode("export")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v(" \n\t\t\t\t\tExport\n\t\t\t\t")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-light btn-sm",
                        on: {
                          click: function($event) {
                            return _vm.poiSet()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("place")
                        ]),
                        _vm._v(" \n\t\t\t\t\tCenter\n\t\t\t\t")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-light btn-sm",
                        class: { active: _vm.mode === "edit" },
                        on: {
                          click: function($event) {
                            return _vm.setMode("edit")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("edit")
                        ]),
                        _vm._v(" \n\t\t\t\t\tEdit\n\t\t\t\t")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-light btn-sm",
                        class: { active: _vm.mode === "remove" },
                        on: {
                          click: function($event) {
                            return _vm.setMode("remove")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("delete")
                        ]),
                        _vm._v(" \n\t\t\t\t\tRemove\n\t\t\t\t")
                      ]
                    )
                  ])
                : _c("contentActions", { attrs: { variant: "blue" } }, [
                    _c("span", { staticClass: "text-white mr-2" }, [
                      _vm._v(
                        "With " + _vm._s(_vm.selected.length) + " selected"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-light btn-sm",
                        class: { active: _vm.mode === "removeSelected" },
                        on: {
                          click: function($event) {
                            return _vm.setMode("removeSelected")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("delete")
                        ]),
                        _vm._v(" \n\t\t\t\t\tRemove\n\t\t\t\t")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-white content-actions-close",
                        on: {
                          click: function($event) {
                            return _vm.clearSelected()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons md-18" }, [
                          _vm._v("close")
                        ])
                      ]
                    )
                  ]),
              _vm._v(" "),
              !_vm.loading && (!_vm.parcels || _vm.parcels.length < 1)
                ? _c("div", { staticClass: "m-3" }, [
                    _c("h4", [_vm._v("No parcels in this collection")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Add parcels to this collection by viewing a parcel and clicking the save button"
                      )
                    ])
                  ])
                : !_vm.loading
                ? _c(
                    "ul",
                    { staticClass: "list-group list-group-flush" },
                    _vm._l(_vm.parcels, function(parcel, index) {
                      return _c(
                        "li",
                        {
                          key: parcel.id,
                          class:
                            "list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer " +
                            (_vm.isSelected(parcel)
                              ? "parcel-unlocked-selected"
                              : ""),
                          on: {
                            click: function($event) {
                              return _vm.routeParcel(parcel)
                            },
                            mouseenter: function($event) {
                              return _vm.mouseenter($event, parcel)
                            },
                            mouseleave: function($event) {
                              return _vm.mouseleave($event, parcel)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm._f("address")(parcel)) +
                                "\n\t\t\t\t\t\t"
                            ),
                            _c("small", { staticClass: "text-secondary" }, [
                              _vm._v(_vm._s(_vm.parcelSub(parcel)))
                            ]),
                            _vm._v(" "),
                            _vm.isSelected(parcel)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "collection-list-remove",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.deSelectParcel(parcel)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      { staticClass: "material-icons md-18" },
                                      [_vm._v("check_box")]
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "collection-list-remove",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.selectParcel(parcel)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "i",
                                      { staticClass: "material-icons md-18" },
                                      [_vm._v("check_box_outline_blank")]
                                    )
                                  ]
                                )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f1f868c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1f868c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collection-parcels.vue
// module id = null
// module chunks = 